module.exports = __webpack_public_path__ + "static/SONO-27001-178bbcc29bf59fc3cd46f7c0d0ab275c.jpg";